/* VERANDA CALCULATOR */
const actionTypes = Object.freeze({
    CLEAR_STATE: 'VERANDA_CALCULATOR/CLEAR_STATE',

    GET_VERANDA_OPTIONS: 'VERANDA_CALCULATOR/GET_VERANDA_OPTIONS',
    GET_VERANDA_OPTIONS_SUCCESS: 'VERANDA_CALCULATOR/GET_VERANDA_OPTIONS_SUCCESS',
    GET_VERANDA_OPTIONS_FAILURE: 'VERANDA_CALCULATOR/GET_VERANDA_OPTIONS_FAILURE',

    CALCULATE_VERANDA: 'VERANDA_CALCULATOR/CALCULATE_VERANDA',
    CALCULATE_VERANDA_SUCCESS: 'VERANDA_CALCULATOR/CALCULATE_VERANDA_SUCCESS',
    CALCULATE_VERANDA_FAILURE: 'VERANDA_CALCULATOR/CALCULATE_VERANDA_FAILURE',

    RESET_CALCULATOR: 'VERANDA_CALCULATOR/RESET_CALCULATOR',
});

export default actionTypes;